export default "__VITE_ASSET__TPY007MO__"